<template lang='pug'>
md-card.md-card-chart(
  @mouseleave.native='onMouseLeave',
  :data-count='hoverCount'
  style='margin: 20px 0; height: calc(100% - 40px);')
  md-card-header.animated.md-card-header-text(
    @mouseenter.native='onMouseOver',
    :data-header-animation='false',
    :class='[{ hovered: imgHovered }, { hinge: headerDown }, { fadeInDown: fixedHeader }]'
    style='background: linear-gradient(60deg, #66bb6a, #43a047);')
    .social-line
      v-row(no-gutters style='padding-left: 8px;')
        v-col(
          style=`padding: 0;
            align-self: center;
            overflow: hidden;
            text-overflow: ellipsis;
            color: white;`)
          h4.title(style='display: inline; color: white;')
            | {{ workspace.name }}
        v-col(cols='auto' style='padding-right: 16px;')
          md-button.md-just-icon.md-round.md-primary(
            v-if='workspaceActiveId == workspace.id'
            style=`
              height: 30px !important;
              width: 30px !important;
              min-width: 30px !important;`)
            v-icon(style='font-size: 30px !important;') mdi-check
          md-button.md-just-icon.md-round(
            @click='setActiveWorkspace(workspace)'
            v-else
            style=`
              height: 30px !important;
              width: 30px !important;
              background-color: rgba(0, 0, 0, 0) !important;`)
            v-icon(style='font-size: 34px !important;')
              | mdi-checkbox-blank-circle-outline
  md-card-content
    .md-card-action-buttons.text-center
      md-button.md-simple.md-info.md-just-icon
        md-icon info
        md-tooltip(md-direction='bottom') {{$t('workspacesCard.viewApiDetails')}}
      md-button.md-simple.md-primary.md-just-icon
        md-icon get_app
        md-tooltip(md-direction='bottom') {{$t('workspacesCard.export')}}
      md-button.md-simple.md-just-icon
        md-icon content_copy
        md-tooltip(md-direction='bottom') {{$t('workspacesCard.duplicate')}}
      md-button.md-simple.md-warning.md-just-icon
        md-icon rate_review
        md-tooltip(md-direction='bottom') {{$t('workspacesCard.rename')}}
    h4.title
      span(style='font-weight: bold; font-size: 14px;') {{$t('workspacesCard.description')}}&nbsp;
      | {{ workspace.description }}
    h4.title(v-if='workspace.updated && workspace.updated.at')
      span(style='font-weight: bold; font-size: 14px;') {{$t('workspacesCard.updated')}}&nbsp;
      | {{ workspace.updated.at }}
    div(v-if='active' style='text-align: center;')
      md-button.md-round.md-sm(
        @click='goToSnapshots(workspace)'
        style=`
          margin: 5px;
          background-color: #e0e0e0 !important;
          color: #3c4858 !important;`)
        v-icon(
          style=`
            color: rgb(60, 72, 88) !important;`
          small
          left) mdi-form-select
        | {{$t('workspacesCard.selectVersion')}}
      md-button.md-round.md-sm(
        v-if='accessWorkspace'
        @click='goToWorkspace(workspace)'
        style=`
          margin: 5px;
          background-color: #9c27b0 !important;
          color: #fff !important;`)
        v-icon(
          style=`
            color: rgb(255, 255, 255) !important;`
          small
          left) mdi-logout-variant
        | {{$t('workspacesCard.accessWorkspace')}}
    h5.title(
      v-else
      style=`
        text-align: center;
        display: flex;
        justify-content: center;`)
      | {{$t('workspacesCard.selectThisWorkspaceToSeeVersions')}}
</template>

<script>
import { mapFields } from 'vuex-map-fields'
export default {
  name: 'WorkspacesCard',
  props: {
    workspace: {
      type: Object,
      required: true
    },
    active: {
      type: Boolean,
      required: true
    }
  },
  data () {
    return {
      hoverCount: 0,
      imgHovered: false,
      fixedHeader: false,
      headerAnimation: true
    }
  },
  computed: {
    ...mapFields('selectedAssistant', ['workspaceActiveId']),
    headerDown () {
      return this.hoverCount > 15
    },
    accessWorkspace () {
      const snapCheckedout = this.$store.getters['snapshots/checkedOutByUser']
      return (
        snapCheckedout &&
        snapCheckedout._source.workspace === this.workspaceActiveId
      )
    }
  },
  methods: {
    setActiveWorkspace (workspace) {
      this.workspaceActiveId = workspace.id
      this.$store.commit('snapshots/setAppliedSnapshot', null)
    },
    onMouseOver: function () {
      if (this.headerAnimation === 'true') {
        this.imgHovered = true
        this.hoverCount++
      }
    },
    onMouseLeave: function () {
      if (this.headerAnimation === 'true') {
        this.imgHovered = false
      }
    },
    evaluateType (value, type) {
      if (type === 'seconds') {
        return value === 1 ? this.$t('workspacesCard.second') : this.$t('workspacesCard.seconds')
      } else if (type === 'minutes') {
        return value === 1 ? this.$t('workspacesCard.minute') : this.$t('workspacesCard.minutes')
      } else if (type === 'hours') {
        return value === 1 ? this.$t('workspacesCard.hour') : this.$t('workspacesCard.hours')
      } else {
        return value === 1 ? this.$t('workspacesCard.day') : this.$t('workspacesCard.days')
      }
    },
    goToSnapshots (workspace) {
      // console.log(workspace)
      this.$router.push('/snapshots')
    },
    goToWorkspace (workspace) {
      // console.log(workspace)
      this.$router.push('/workspace')
    }
  }
}
</script>

<style scoped>
/* .md-button.md-warning.access-workspace {
  background-color: #e0e0e0 !important;
} */
.md-button .access-workspace {
  background-color: #e0e0e0 !important;
}
.md-button .access-workspace:hover,
.md-button .access-workspace:focus,
.md-button .access-workspace:active,
.md-button .access-workspace.active,
.md-button .access-workspace:active:focus,
.md-button .access-workspace:active:hover,
.md-button .access-workspace.active:focus,
.md-button .access-workspace.active:hover {
  background-color: #e0e0e0 !important;
  color: #fff !important;
  -webkit-box-shadow: 0 14px 26pxnode -12px rgba(59, 89, 152, 0.42),
    0 4px 23px 0px rgba(0, 0, 0, 0.12), 0 8px 10px -5px rgba(59, 89, 152, 0.2) !important;
  box-shadow: 0 14px 26px -12px rgba(59, 89, 152, 0.42),
    0 4px 23px 0px rgba(0, 0, 0, 0.12), 0 8px 10px -5px rgba(59, 89, 152, 0.2) !important;
}
</style>
